// export const API_BASE_URL = 'http://localhost:8080/api/v1';
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
export const GOOGLE_CLIENT_SECRET = import.meta.env.VITE_GOOGLE_CLIENT_SECRET || '';